// extracted by mini-css-extract-plugin
export var articleContainer = "social-share-module--article-container--K15Ze";
export var articleHeader = "social-share-module--article-header--VAnmd";
export var articleOverview = "social-share-module--article-overview---KtIJ";
export var articleTitle = "social-share-module--article-title--m301G";
export var bannerImage = "social-share-module--banner-image--jlJwt";
export var socialShareButtonsContainer = "social-share-module--social-share-buttons-container--R6VWo";
export var socialShareContainer = "social-share-module--social-share-container--QcolP";
export var socialShareText = "social-share-module--social-share-text--OxrfY";